<script setup lang="ts">
import { ConsultingPharmaProps } from "./ConsultingPharma.props"

defineProps<ConsultingPharmaProps>()
</script>

<template>
  <section
    class="
      banner-help-consulting_pharma
      md:grid-container
      relative
      overflow-hidden
      rounded-2xl
      bg-tiffany-10
      px-4
      pb-9
      pt-6
      md:px-10
      md:pb-8
      md:pt-10
    "
  >
    <!-- Text container (left-column) -->
    <div class="pharma-text-container md:col-span-6">
      <p class="hyppo-bold md:mammoth-bold mb-4">{{ title }}</p>

      <UtilsMarkdown
        class="
          beaver
          md:pig
          markdown__paragraph-margin-bottom-4
          mb-7
          text-black-80
          md:mb-6
        "
        v-if="callToActionText"
        :content="callToActionText"
      />

      <UtilsButton
        v-if="cta"
        class="
          custom-btn-pig-medium
          custom-btn-no-padding
          custom-btn-underlined
          custom-btn-hover-green-300
          text-green-main
          underline
          [&>span]:justify-start
        "
        theme="ghost-green"
        v-bind="cta"
      />
    </div>

    <!-- Icon (right-column) -->
    <div
      class="
        ml-auto
        w-fit
        md:col-span-6
        md:m-0
        md:flex
        md:w-auto
        md:justify-center
      "
    >
      <!-- Mobile -->
      <div
        class="mobile-icon-wrapper relative -mr-9 mt-5 pl-32 md:hidden md:pl-0"
      >
        <!-- Icon -->

        <UtilsIcon
          name="CustomerServiceMail.svg"
          color="tiffany-main"
          class="relative h-56 w-56"
        />
        <UtilsIcon
          name="CustomerServiceMail.svg"
          color="tiffany-main"
          class="absolute -right-6 bottom-5 h-56 w-56 opacity-10"
        />

        <!-- Cloud message Container -->
        <div class="absolute right-32 top-20 z-10 md:right-96 md:top-20">
          <!-- Cloud Message -->
          <div class="relative">
            <UtilsIcon name="MessageCloud.svg" />
            <p class="beaver absolute right-3 top-4 w-48 text-slate-main">
              {{ messageText }}
            </p>
          </div>
        </div>
      </div>

      <!-- Desktop  -->
      <div class="desktop-icon-wrapper">
        <div class="top absolute bottom-0 hidden md:block">
          <!-- Icons -->
          <UtilsIcon
            name="CustomerServiceMail.svg"
            color="tiffany-main"
            class="absolute -left-6 top-14 h-72 w-72"
          />
          <UtilsIcon
            name="CustomerServiceMail.svg"
            color="tiffany-main"
            class="mt-8 h-72 w-72 opacity-10"
          />

          <!-- Cloud Message -->
          <div class="absolute bottom-14 right-60 z-10 h-[81px] w-[221px]">
            <UtilsIcon name="MessageCloud.svg" />
            <p
              class="
                beaver
                absolute
                right-3
                top-4
                w-48
                text-slate-main
                lg:top-[14px]
              "
            >
              {{ messageText }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
